module.exports = __webpack_public_path__ + "media/images/mailer/logo_full-efefe08462ede002abb7fc1e69005cbb.png";